export default {
  default: {
    fontSize: "14px",
    fontWeight: 400,
  },
  main: {
    title: {
      fontSize: "30px",
      fontWeight: 600,
    },
    h1: {
      fontSize: "20px",
      fontWeight: 500,
    },
    h1Accent: {
      fontSize: "20px",
      fontWeight: 600,
    },
    h2: {
      fontSize: "18px",
      fontWeight: 600,
    },
    h3: {
      fontSize: "16px",
      fontWeight: 600,
    },
    text: {
      fontSize: "16px",
      fontWeight: 400,
    },
    textAccent: {
      fontSize: "16px",
      fontWeight: 500,
    },
    body: {
      fontSize: "14px",
      fontWeight: 400,
    },
    bodyAccent: {
      fontSize: "14px",
      fontWeight: 600,
    },
    caption: {
      fontSize: "13px",
      fontWeight: 600,
    },
    primary: {
      fontSize: "16px",
      fontWeight: 600,
    },
    description: {
      fontSize: "11px",
      fontWeight: 500,
    },
  },
  button: {
    tooltip: {
      fontSize: "14px",
      fontWeight: 600,
    },
    unique: {
      fontSize: "13px",
      fontWeight: 600,
    },
  },
  tooltip: {
    text: {
      fontSize: "16px",
      fontWeight: 500,
    },
    textAccent: {
      fontSize: "16px",
      fontWeight: 900,
    },
    secondary: {
      fontSize: "12px",
      fontWeight: 400,
    },
  },
  mobile: {
    body: {
      fontSize: "14px",
      fontWeight: 600,
    },
    body2: {
      fontSize: "14px",
      fontWeight: 400,
    },
    h2: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
};
